import { FilterValue } from '../../types';
import { isNumberType } from '../../utils';

export const parseFilterValue = (value: string, type: string): FilterValue => {
  if (isNumberType(type) && value.length > 0 && !isNaN(Number(value))) {
    return Number(value);
  }
  return value;
};
